<div class="loaderwrapper" *ngIf="loader">
    <span class="loader"></span>
</div>

<section class="dashboard-main container-fluid">
    <div class="contents-main">
        <div class="card table-card">
            <!-- Title, filters and the page actions share one row at the top
                 of the card rather than stacking above it. -->
            <div class="table-toolbar">
                <h1 class="table-toolbar__title">Users Role</h1>
                <div class="sb-filter-holder sb-filter-holder--inline">
                    <!-- User Type -->
                    <div class="input-wrapper">
                        <ng-select placeholder="User Type" (change)="selectTypelistStatus($event)"
                            class="sb-filter-field sb-filter-field--md">
                            <ng-option *ngFor="let user of typeDropdownList" [value]="user.id">
                                {{ user.name }}
                            </ng-option>
                        </ng-select>
                    </div>
                    <!-- Search -->
                    <div class="btn-group sb-filter-search-group" role="group">
                        <input type="text" class="sb-filter-field sb-filter-search-input" placeholder="Search"
                            (input)="searchData($event)">
                        <button type="button" class="btn sb-filter-search-btn">
                            <!-- <i class="ri-search-line"></i> -->
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path
                                    d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M17.5 17.5L13.875 13.875" stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>
                <button type="button" class="btn btn-dark rounded" (click)="openAddPopUp(content)">
                    <i class="ri-add-line label-icon align-middle fs-16 me-2"></i>
                    Add New Role
                </button>
            </div>
            <div class="table-wrap" [class.is-loading]="tableLoader">
                <div class="loaderwrapper" *ngIf="tableLoader">
                    <span class="loader"></span>
                </div>
                <div class="table-main">
                    <div>
                        <table class="table-data">
                            <thead>
                                <tr>
                                    <th scope="col">Sr. No</th>
                                    <th scope="col">Role Name</th>
                                    <th scope="col">User Type</th>
                                    <th scope="col">Description</th>
                                    <th scope="col">Assigned Users</th>
                                    <th scope="col">Last Updated</th>
                                    <th scope="col">Status</th>
                                    <th scope="col" style="width: 80px; text-align: center" *ngIf="hasAnyActionPermission">
                                        Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of userTypeList; let i = index">
                                    <td>{{ item.srNo }}</td>
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.user_type_name }}</td>
                                    <td>{{ item.description || '-' }}</td>
                                    <td>{{ item.users_count || 0}}</td>
                                    <td>{{ item.last_updated | date: 'short'}}</td>
                                    <td>
                                        <span class="badge badge-custom badge-sm d-flex" [class.badge]="true"
                                            [class.badge-success]="item.status" [class.badge-danger]="!item.status">
                                            {{ item.status ? 'Active' : 'Inactive' }}
                                        </span>
                                    </td>
                                    <td *ngIf="hasAnyActionPermission">
                                        <ul class="list-inline hstack gap-2 mb-0">
                                            <!-- <li class="list-inline-item edit" data-bs-toggle="tooltip"
                                                    data-bs-trigger="hover" data-bs-placement="top" title="Active/Inactive">
                                                    <div class="custom-control custom-switch">
                                                        <input type="checkbox" class="custom-control-input"
                                                            [id]="'status-' + item.id" 
                                                            [checked]="item.status"
                                                            (change)="toggleUserRoleStatus(item)">
                                                        <label class="custom-control-label" [for]="'status-' + item.id"></label>
                                                    </div>
                                                </li> -->
                                            <li class="list-inline-item view" data-bs-toggle="tooltip"
                                                *ngIf="permissionsReady && permissions.canEdit" data-bs-trigger="hover"
                                                data-bs-placement="top" title="Assign Permissions">
                                                <a title="Assign Permissions" *ngIf="item.status"
                                                    (click)="openPermissionsModal(item.id, item)"
                                                    class="d-inline-block view-item-btn">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M8.17997 16.02C7.41997 15.95 6.66998 15.6 6.08998 14.99C4.76998 13.6 4.76998 11.32 6.08998 9.93001L8.27998 7.63002C9.59998 6.24002 11.77 6.24002 13.1 7.63002C14.42 9.02002 14.42 11.3 13.1 12.69L12.01 13.84"
                                                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                        <path
                                                            d="M15.82 7.97998C16.58 8.04998 17.33 8.39998 17.91 9.00998C19.23 10.4 19.23 12.68 17.91 14.07L15.72 16.37C14.4 17.76 12.23 17.76 10.9 16.37C9.57997 14.98 9.57997 12.7 10.9 11.31L11.99 10.16"
                                                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                        <path
                                                            d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                                                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                    </svg>

                                                </a>
                                            </li>
                                            <!-- <li class="list-inline-item view" data-bs-toggle="tooltip"
                                                    *ngIf="permissionsReady && permissions.canView" data-bs-trigger="hover"
                                                    data-bs-placement="top" title="View">
                                                    <a title="View User Role" (click)="openViewPopUp(item, content)"
                                                        class="d-inline-block view-item-btn">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="21.841"
                                                            height="14.56" viewBox="0 0 21.841 14.56">
                                                            <g id="eye" transform="translate(-1.498 -9)">
                                                                <circle id="Ellipse_1436" data-name="Ellipse 1436"
                                                                    cx="3.105" cy="3.105" r="3.105"
                                                                    transform="translate(9.315 13.175)"
                                                                    fill="currentColor" />
                                                                <path id="Path_5515" data-name="Path 5515"
                                                                    d="M23.1,15.488a15.422,15.422,0,0,0-4.517-4.574A11.43,11.43,0,0,0,12.4,9a10.9,10.9,0,0,0-5.654,1.643,16.574,16.574,0,0,0-4.991,4.826,1.452,1.452,0,0,0-.029,1.617A15.2,15.2,0,0,0,6.2,21.666a11.271,11.271,0,0,0,6.2,1.894,11.478,11.478,0,0,0,6.2-1.9,15.2,15.2,0,0,0,4.508-4.592,1.465,1.465,0,0,0,0-1.582Zm-10.685,5.16a4.368,4.368,0,1,1,4.368-4.368,4.368,4.368,0,0,1-4.368,4.368Z"
                                                                    fill="currentColor" />
                                                            </g>
                                                        </svg>
                                                    </a>
                                                </li> -->
                                            <li class="list-inline-item edit" data-bs-toggle="tooltip"
                                                *ngIf="permissionsReady && permissions.canEdit" data-bs-trigger="hover"
                                                data-bs-placement="top" title="Edit">
                                                <a title="Edit User Role" (click)="openEditPopUp(item, content)"
                                                    class="d-inline-block edit-item-btn">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14.433" height="18"
                                                        viewBox="8 4 14.433 18">
                                                        <path
                                                            d="M8.9 20.2h12.6a.9.9 0 0 1 0 1.8H8.9a.9.9 0 1 1 0-1.8ZM8 15.7l9-9 2.7 2.7-9 9H8v-2.7Zm9.9-9.9L19.7 4l2.7 2.7-1.8 1.8-2.7-2.7Z"
                                                            fill="currentColor" />
                                                    </svg>
                                                </a>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                                <!-- NO VIEW PERMISSION -->
                                <tr *ngIf="permissionsReady && !permissions.canView">
                                    <td colspan="100%">
                                        <div class="no-access text-center p-4">
                                            You don’t have permission to view this data.
                                        </div>
                                    </td>
                                </tr>

                                <!-- NO RECORDS -->
                                <tr
                                    *ngIf="permissionsReady && permissions.canView && (!userTypeList || userTypeList.length === 0)">
                                    <td colspan="100%">
                                        <p class="not-found-message p-4 text-center">
                                            No records found.
                                        </p>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <div class="table-meta">
                        <div class="entries flex-column align-items-start gap-3">
                            <label class="show-entries-list p-0">
                                Show
                                <select [formControl]="pageSizeControl" class="form-control form-control-sm"
                                    (change)="changePageSize()">
                                    <option *ngFor="let limit of pageRecordOptions" [value]="limit.value">
                                        {{ limit.label }}
                                    </option>
                                </select>
                                Entries
                            </label>
                            <span>Total Records: {{ this.total_items }}</span>
                        </div>
                        <nav class="table-pagination">
                            <ul>
                                <li>
                                    <div class="go-to-page d-flex align-items-center">
                                        <label>Go to Page:</label>
                                        <input type="number" class="form-control form-control-sm" [(ngModel)]="pageToGo"
                                            min="1" [max]="total_pages"
                                            (keydown.enter)="goToPage(pageToGo); pageToGo = null">
                                        <div class="input-group-append">
                                            <button class="btn btn-primary" type="button"
                                                (click)="goToPage(pageToGo); pageToGo = null"
                                                [disabled]="pageToGo < 1 || pageToGo > total_pages">Go</button>
                                        </div>
                                    </div>
                                </li>
                                <li><a class="init-bg" id="firstPage" (click)="goToPage(1)"
                                        [class.disabled]="current_page === 1">1</a></li>
                                <li><a class="no-bg" id="prevPage" (click)="navigatePage('prev')"><i
                                            class="fa fa-chevron-left"></i></a></li>
                                <li><a class="active">{{ current_page }}</a></li>
                                <li><a class="no-bg" id="nextPage" (click)="navigatePage('next')"
                                        [class.disabled]="current_page === total_pages"><i
                                            class="fa fa-chevron-right"></i></a></li>
                                <li><a class="init-bg" id="lastPage" (click)="goToPage(total_pages)"
                                        [class.disabled]="current_page === total_pages">{{ this.total_pages }}</a></li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Add/Edit Modal -->
<ng-template #content let-modal>
    <form [formGroup]="userRoleForm" (ngSubmit)="onSubmit()">
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">
                {{ isViewMode ? 'View User Role' : (isEditMode ? 'Edit User Role' : 'Add User Role') }}
            </h4>
            <button type="button" class="btn-close" aria-label="Close"
                (click)="modal.dismiss('Cross click'); resetForm()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                    <rect y="0.696289" width="24" height="24" rx="12" fill="white" />
                    <path d="M6.99988 7.69653L12.0514 12.748L17.1029 7.69653" stroke="currentColor" stroke-width="1.6"
                        stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.99995 18.3679L12.0505 13.3164L17.1021 18.3679" stroke="currentColor" stroke-width="1.6"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>

        <div class="modal-body">
            <div class="row">
                <div class="col-md-12 form-styles my-3">
                    <label for="user_type">User Type <span class="text-danger">*</span></label>
                    <ng-select formControlName="user_type" id="user_type" placeholder="Select User Type"
                        [class.is-invalid]="userRoleForm.get('user_type')?.invalid && userRoleForm.get('user_type')?.touched">
                        <ng-option *ngFor="let user of typeDropdownList" [value]="user.id">
                            {{ user.name }}
                        </ng-option>
                    </ng-select>
                    <div class="invalid-feedback d-block"
                        *ngIf="userRoleForm.get('user_type')?.invalid && userRoleForm.get('user_type')?.touched">
                        <span *ngIf="userRoleForm.get('user_type')?.errors?.['required']">
                            User Type is required
                        </span>
                    </div>
                </div>

                <div class="col-md-12 mb-3 form-styles">
                    <label for="name">Role Name <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="name" formControlName="name"
                        placeholder="Enter role name"
                        [class.is-invalid]="userRoleForm.get('name').invalid && userRoleForm.get('name').touched">
                    <small class="text-danger"
                        *ngIf="userRoleForm.get('name').invalid && userRoleForm.get('name').touched">
                        <span *ngIf="userRoleForm.get('name').errors?.['required']">Name is required</span>
                        <span *ngIf="userRoleForm.get('name').errors?.['minlength']">Name must be at least 2
                            characters</span>
                    </small>
                </div>

                <div class="col-md-12 mb-3 form-styles">
                    <label for="description">Description</label>
                    <textarea class="form-control" id="description" formControlName="description" cols="30" rows="3"
                        placeholder="Enter description"></textarea>
                </div>

                <div class="col-md-12 mb-3 form-styles">
                    <label for="userStatus">Status <span class="text-danger">*</span></label>
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="userStatus" formControlName="status">
                        <label class="custom-control-label" for="userStatus">
                            {{ userRoleForm.get('status').value ? 'Active' : 'Inactive' }}
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer no-bg">
            <button type="button" class="btn btn-outline-dark" aria-label="Close"
                (click)="modal.dismiss('Cross click'); resetForm()">
                {{ isViewMode ? 'Close' : 'Cancel' }}
            </button>
            <button type="submit" class="btn btn-orange" *ngIf="!isViewMode" [disabled]="userRoleForm.invalid">
                {{ isEditMode ? 'Update' : 'Save' }}
            </button>
        </div>
    </form>
</ng-template>

<!-- Hierarchy Modal (if needed) -->
<ng-template #contentHierarchy let-modal>
    <form [formGroup]="ruleForm" (ngSubmit)="onSubmitRule()">
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title">
                User Creation Hierarchy
            </h4>
            <button type="button" class="btn-close" aria-label="Close"
                (click)="modal.dismiss('Cross click'); resetRuleForm()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                    <rect y="0.696289" width="24" height="24" rx="12" fill="white" />
                    <path d="M6.99988 7.69653L12.0514 12.748L17.1029 7.69653" stroke="currentColor" stroke-width="1.6"
                        stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.99995 18.3679L12.0505 13.3164L17.1021 18.3679" stroke="currentColor" stroke-width="1.6"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>

        <div class="modal-body">
            <div class="row">
                <div class="col-md-12 form-styles my-3">
                    <label for="parentUserType">Parent User Type <span class="text-danger">*</span></label>
                    <ng-select formControlName="parentUserType" id="parentUserType"
                        placeholder="Select Parent User Type"
                        [class.is-invalid]="ruleForm.get('parentUserType')?.invalid && ruleForm.get('parentUserType')?.touched">
                        <ng-option *ngFor="let user of typeDropdownList" [value]="user.id">
                            {{ user.name }}
                        </ng-option>
                    </ng-select>
                    <div class="invalid-feedback d-block"
                        *ngIf="ruleForm.get('parentUserType')?.invalid && ruleForm.get('parentUserType')?.touched">
                        <span *ngIf="ruleForm.get('parentUserType')?.errors?.['required']">
                            Parent User Type is required
                        </span>
                    </div>
                </div>

                <div class="col-md-12 form-styles my-3">
                    <label for="subordinateUserTypes">Can Create Subordinate User Types <span
                            class="text-danger">*</span></label>
                    <ng-select formControlName="subordinateUserTypes" id="subordinateUserTypes"
                        placeholder="Select Subordinate User Types"
                        [class.is-invalid]="ruleForm.get('subordinateUserTypes')?.invalid && ruleForm.get('subordinateUserTypes')?.touched"
                        [multiple]="true" [disabled]="!selectedParentType">
                        <ng-option *ngFor="let user of filteredSubordinateList" [value]="user.id">
                            {{ user.name }}
                        </ng-option>
                    </ng-select>
                    <div class="invalid-feedback d-block"
                        *ngIf="ruleForm.get('subordinateUserTypes')?.invalid && ruleForm.get('subordinateUserTypes')?.touched">
                        <span *ngIf="ruleForm.get('subordinateUserTypes')?.errors?.['required']">
                            At least one Subordinate User Type is required
                        </span>
                        <span *ngIf="ruleForm.get('subordinateUserTypes')?.errors?.['minLengthArray']">
                            At least one Subordinate User Type must be selected
                        </span>
                    </div>
                    <small class="text-muted" *ngIf="!selectedParentType">
                        Please select a Parent User Type first
                    </small>
                </div>
                <div class="col-md-12">
                    <button type="submit" class="btn btn-orange d-block ms-auto" [disabled]="ruleForm.invalid">
                        Add Rule
                    </button>
                </div>
            </div>

            <div *ngIf="existingRules.length > 0" class="mt-4">
                <h5>Existing Rules</h5>
                <div class="rules-list">
                    <div class="rule-item d-flex justify-content-between align-items-center mb-2 p-2 border rounded"
                        *ngFor="let rule of existingRules">
                        <span>{{ rule.message }}</span>
                        <button type="button" class="btn btn-sm btn-danger" (click)="deleteRule(rule.id)">
                            Delete
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer no-bg">
            <button type="button" class="btn btn-outline-dark" aria-label="Close"
                (click)="modal.dismiss('Cross click'); resetRuleForm()">
                Close
            </button>
        </div>
    </form>
</ng-template>
<app-user-permissions-modal></app-user-permissions-modal>